export default "__VITE_ASSET__Fp559saF__"